
$(".header").find("nav").on("mouseenter", function(){
  $(".header").addClass('show')
})

// $(".header").find("nav").on("mouseleave", function () {
//   $(".header .navbar .navbar-nav").find(".nav-item").removeClass('show');
// })

$(".header").on("mouseleave", function(){
  $(".header").removeClass('show')

})


$(".header .navbar .navbar-nav").find(".dropdown").on("mouseenter", function () {
  var _index = $(this).index();
  // $(".header .navbar .navbar-nav").find(".dropdown").removeClass('show');
  $(this).addClass('show');
})

$(".header .navbar .navbar-nav").find(".dropdown").on("mouseleave", function (){
  $(this).removeClass('show');
})


var banner = new Swiper(".banner", {
  loop: true, // 循环模式选项
  autoHeight: true, //高度随内容变化
  // 如果需要分页器
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  autoplay: {
    delay: 6000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },

  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".banner .next",
    prevEl: ".banner .prev",
  },

  on: {
    slideChangeTransitionEnd: function () {},
  },
  // 如果需要滚动条
});

var probox = new Swiper(".probox", {
  loop: true, // 循环模式选项
  autoHeight: true, //高度随内容变化
  // 如果需要分页器
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  slidesPerView: 1,
  spaceBetween: 10,
  autoplay: {
    delay: 4000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },

  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".product .next",
    prevEl: ".product .prev",
  },
  breakpoints: { 
    768: {  //当屏幕宽度大于等于768 
      slidesPerView: 2,
      spaceBetween: 20,
    },
    992: {  //当屏幕宽度大于等于768 
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
  on: {
    slideChangeTransitionEnd: function () {},
  },
  // 如果需要滚动条
});





var advbox = new Swiper(".advbox", {
  loop: false, // 循环模式选项
  autoHeight: true, //高度随内容变化
  // 如果需要分页器
  pagination: {
    el: ".adv .swiper-pagination",
    clickable: true,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  autoplay: {
    delay: 4000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },

  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".advbox .next",
    prevEl: ".advbox .prev",
  },

  on: {
    slideChangeTransitionEnd: function () {
      $(".adv .navbar").find("li").removeClass('active').eq(this.realIndex).addClass('active');
    },
  },
  // 如果需要滚动条
});

$(".adv .navbar").find("li").on("mouseenter", function(){
  var _index = $(this).index();
  $(".adv .navbar").find("li").removeClass('active').eq(_index).addClass('active');
  advbox.slideTo(_index, 1000, false);
})



var licbox = new Swiper(".licbox", {
  loop: true, // 循环模式选项
  // 如果需要分页器
  slidesPerView: 1,
  autoHeight:false,
	centeredSlides: true,
  spaceBetween: 0,
  pagination: {
    el: ".lichen .swiper-pagination",
    clickable: true,    
  },
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },

  breakpoints: { 
    768: {  //当屏幕宽度大于等于768 
      slidesPerView: 2,
      spaceBetween: 20,
    },
    992: {  //当屏幕宽度大于等于768 
      slidesPerView: 3,
  spaceBetween: 50,
    },
  },

  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".lichen .next",
    prevEl: ".lichen .prev",
  },

  on: {    
  },
  // 如果需要滚动条
});

var zizhibox = new Swiper(".zizhibox", {
  loop: true, // 循环模式选项
  loopedSlides: 5,  
  // 如果需要分页器
  watchSlidesProgress: true,
  slidesPerView: 'auto',
	centeredSlides: true,
  spaceBetween: 0,
  pagination: {
    el: ".zizhi .swiper-pagination",
    clickable: true,    
  },
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },

  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".zizhi .next",
    prevEl: ".zizhi .prev",
  },

  on: {
    progress: function(progress) {
      
			for (i = 0; i < this.slides.length; i++) {
				var slide = this.slides.eq(i);
				var slideProgress = this.slides[i].progress;
				modify = 1;
				if (Math.abs(slideProgress) > 1) {
					modify = (Math.abs(slideProgress) - 1) * 0.02 + 1;
				}
				translate = slideProgress * modify * (this.slidesSizesGrid[i]/2) + 'px';
				scale = 1 - Math.abs(slideProgress) / 5;
				zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
				slide.transform('translateX(' + translate + ') scale(' + scale + ')');
				slide.css('zIndex', zIndex);
				slide.css('opacity', 1);
				if (Math.abs(slideProgress) > 3) {
					slide.css('opacity', 0);
				}
			}
		},
		setTransition: function(transition) {
			for (var i = 0; i < this.slides.length; i++) {
				var slide = this.slides.eq(i)
				slide.transition(transition);
			}

		}
  },
  // 如果需要滚动条
});

var aboutbox = new Swiper(".aboutbox", {
  loop: true, // 循环模式选项
  autoHeight: true, //高度随内容变化
  // 如果需要分页器
  pagination: {
    el: ".about .swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      var text = "";
      switch (index) {
        case 0:
          text = "深圳";
          break;
        case 1:
          text = "江西";
          break;      
      }
      return '<span class="' + className + '"><b>' + text + "</b></span>";
    },
  },
  slidesPerView: 1,
  spaceBetween: 0,
  autoplay: {
    delay: 6000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },

  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".aboutbox .next",
    prevEl: ".aboutbox .prev",
  },

  on: {
    slideChangeTransitionEnd: function () {},
  },
  // 如果需要滚动条
});


var shopthumbs = new Swiper('.shopthumbs',{
  spaceBetween: 10,
  slidesPerView: 3,
  watchSlidesVisibility: true,//防止不可点击
})


var bigImg = new Swiper(".bigImg", {
  loop: false, // 循环模式选项
  // 如果需要分页器
  pagination: {
    el: ".shopbigimg .swiper-pagination",
    clickable: true,  
  },
  slidesPerView: 1,
  spaceBetween: 0,
  autoplay: {
    delay: 4000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },

  thumbs: {
    swiper: shopthumbs,
  },
  
  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".shopbigimg .next",
    prevEl: ".shopbigimg .prev",
  },

  on: {
    slideChangeTransitionEnd: function () {},
  },
  // 如果需要滚动条
});


var pagezizhibox = new Swiper(".pagezizhibox", {
  loop: true, // 循环模式选项
  autoHeight: true, //高度随内容变化
  // 如果需要分页器
  pagination: {
    el: ".pagezizhi .swiper-pagination",
    clickable: true,  
  },
  slidesPerView: 2,
  spaceBetween: 10,
  autoplay: {
    delay: 4000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },

  breakpoints: { 
    768: {  //当屏幕宽度大于等于768 
      slidesPerView: 2,
      spaceBetween: 20,
    },
    992: {  //当屏幕宽度大于等于768 
      slidesPerView: 4,
  spaceBetween: 50,
    },
  },

  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".aboutbox .next",
    prevEl: ".aboutbox .prev",
  },

  on: {
    slideChangeTransitionEnd: function () {},
  },
  // 如果需要滚动条
});



$("#kefu2").find(".close").on("click", function(e){ 
  e.stopPropagation();
  $("#kefu2").removeClass("open");  
})

$("#kefu2").on('click', function(){
  $("#kefu2").addClass("open");  
})


$(window).on("scroll", function(){
  var scrollTop = $(window).scrollTop(),
      scroll_bottom = $(window).height() + scrollTop;
  var foot_top = $("footer").offset().top;
  if(scroll_bottom >= foot_top){
    $(".backtop").addClass('show');
  }else{
    $(".backtop").removeClass('show');
  }
  
})

$(".backtop").on("click", function(e){
  
  $("html, body").animate({
    scrollTop: 0
  },200)
})


$(".news .navbar").find("li").on("mouseenter", function(){
  var _index = $(this).index();
  $(".news .navbar").find("li").removeClass('active').eq(_index).addClass('active');
  $(".news .tab-list").removeClass('show').eq(_index).addClass('show');
})


$(".pagenum").find('dl').on("mouseenter", function(){
  var _index = $(this).index();
  $(".pagenum").find('dl').removeClass("active").eq(_index).addClass('active');
})


$('.fancybox').fancybox();


$("#myform").on('submit',function(){
  var url = $(this).attr('action'),
      data = $(this).serialize();  
      
  $.post(url,data,function(res){
    var bq = res.code == 1 ? '<i class="iconfont icon-kaixin text-green-500 font-bold mr-1"></i>' : '<i class="iconfont icon-bukaixin text-red-500 font-bold mr-1"></i>';
    if(res.code == 0){
      art.dialog({title:'<i class="iconfont icon-tishi font-normal mr-1"></i>提示', id:'tips', fixed:true, content: bq+' '+res.tips}, function(){
        $("#"+res.field).focus();
      });
    }else{
      art.dialog({title:'<i class="iconfont icon-tishi font-normal mr-1"></i>提示', id:'tips', fixed:true, content: bq+' '+res.tips}, function(){location.reload();});
    }
    
  },"json")
  return false;
})


$(".video").on("click", function(){
  var html = "<div class='video_bg'></div><div class='video_box'><iframe height='100%' width='100%' src='https://player.youku.com/embed/XNTg2OTQzNjI2NA==' frameborder=0 'allowfullscreen'></iframe><span class='close'><i class='iconfont icon-guanbi'></i></span></div>";

  if($(".video_box").length>0){
    $(".video_bg, .video_box").show();
  }else{
    $("body").append(html);
  }
  

  $(".video_bg, .video_box .close").on("click", function(){
      
      $(".video_bg, .video_box").hide();
  })
})


$(".navbar-toggler").on("click", function(){
  $(".navbar").toggleClass('show');
})

$(".link-toggle").on("click", function(e){
  e.stopPropagation();
  e.preventDefault();
  if($(this).parents(".nav-item").hasClass("open")){
    $(this).parents(".nav-item").removeClass("open");
  }else{
    $(".navbar").find(".nav-item").removeClass("open");
    $(this).parents(".nav-item").addClass("open");
  }
  
  
})